import { AdminLayout } from '@/components/layouts'
import { QuizForm } from './QuizForm'

interface Community {
  id: number
  name: string
}

interface Answer {
  text: string
}

interface Quiz {
  id: number
  title: string
  question: string
  answers: Answer[]
  correct_answer_indices: number[]
  category: string
  difficulty_level: number
  points_reward: number
  week_start_date: string
  published: boolean
  community_id: number
}

interface EditProps {
  quiz: Quiz
  communities: Community[]
}

export default function Edit({ quiz, communities }: EditProps) {
  return (
    <AdminLayout
      title="Modifier Quiz"
      breadcrumbs={[
        { label: 'Quiz Hebdomadaires', href: '/admin/weekly_quizzes' },
        { label: quiz.title, href: `/admin/weekly_quizzes/${quiz.id}` },
        { label: 'Modifier' }
      ]}
    >
      <div className="max-w-3xl">
        <QuizForm
          quiz={quiz}
          communities={communities}
          onSubmit={`/admin/weekly_quizzes/${quiz.id}`}
          isEdit
        />
      </div>
    </AdminLayout>
  )
}
